import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import { observer } from 'mobx-react';
import { WhatsNewContainer } from 'owa-whats-new';
import { logUsage } from 'owa-analytics';
import strings from 'owa-strings/owa-whatsnew-strings';
var WhatsNewPane = /** @class */ (function (_super) {
    tslib_1.__extends(WhatsNewPane, _super);
    function WhatsNewPane(props) {
        return _super.call(this, props) || this;
    }
    WhatsNewPane.prototype.componentDidMount = function () {
        logUsage('whatsNewPaneOpened');
    };
    WhatsNewPane.prototype.render = function () {
        var _this = this;
        return (React.createElement(HeaderFlexPane, { title: strings.whatsNew_FlexPane_Title, content: React.createElement(WhatsNewContainer, null), onDismiss: function () {
                _this.props.onDismiss();
            } }));
    };
    WhatsNewPane = tslib_1.__decorate([
        observer
    ], WhatsNewPane);
    return WhatsNewPane;
}(React.Component));
export default WhatsNewPane;
//# sourceMappingURL=WhatsNewPane.js.map